<div class="trezo-card-title">
    <h6 class="!mb-3 text-left">
        Training Wise Payment Disbursed (₹) 
    </h6>
</div>
<div>
    <ag-charts *ngIf="isBrowser && options" [options]="options" style="width: 100%; height: 400px; display: block"
    ></ag-charts>
</div>
